import request from 'reqwest';
import when from 'when';
import LoginConstants from '../constants/LoginConstants';
import store from 'store';

class AuthService {
  login(email, password) {
    return this.handleAuth(when(request({
      url: LoginConstants.LOGIN_URL,
      method: 'POST',
      crossOrigin: true,
      type: 'json',
      data: {
        merchant: {
          email,
          password
        }
      }
    })));
  }

  getUser() {
    return store.get('userRf1');
  }

  handleAuth(loginPromise) {
    return loginPromise;
  }
}

export default new AuthService()



/** WEBPACK FOOTER **
 ** ./src/services/AuthService.js
 **/